import React, { useContext, useEffect, useRef } from "react";
import html2pdf from "html2pdf.js";
import convertToWords from "./ConvertToWords";
import { AuthContext } from "../../context/AuthContext";
import { useDistributor } from "../../hooks/useDistributor";

// Table Styles
const styles = {
  tableCell: {
    border: "1px solid black",
    padding: "8px",
    borderCollapse: "collapse",
    textAlign: "center",
    verticalAlign: "middle",
  },
  verticalTableCell: {
    border: "1px solid black",
    padding: "8px",
    borderCollapse: "collapse",
    textAlign: "end",
    verticalAlign: "middle",
  },
};

// InvoiceTemplate Component
const InvoiceTemplate = React.forwardRef(({ data }, invoiceRef) => {
  const totalAmount = data.products.reduce(
    (total, item) => total + parseFloat(item.distributorPrice || item.retailerPrice || 0),
    0
  );

  const {role}=useContext(AuthContext)
  const user=useDistributor();

  useEffect(()=>{
    console.log(user);
  },[])

  return (
    <div
      ref={invoiceRef}
      style={{ padding: "20px", fontFamily: "Arial", backgroundColor: "white" }}
    >
      {/* Header Section */}

      {role.toLowerCase()==='admin' ?

     (<div className="flex justify-between my-3">
        <div className="text-xs text-gray-600 w-2/3">
          <p>
            <strong>Contact Us: </strong> "abc@imagine.com" || "09312409812"
          </p>
          <p>
            <strong>Registered Address: </strong> 2C, Astra Towers, 715, 7th
            Floor, 1, Action Area IIC, Newtown, Kolkata, West Bengal 700161
          </p>
        </div>
      </div>):(<div className="flex justify-between my-3">
        <div className="text-xs text-gray-600 w-2/3">
          <p className="text-black font-medium text-sm underline">Transferred By :-</p>
          <p>
  <strong>Name: </strong> {user?.name || "N/A"}
</p>
<p>
  <strong>Address: </strong>
  {user?.city},{user?.address},{user?.state},{user?.pincode}
</p>
<p>
  <strong>Contact: </strong>
  {user?.email || "N/A"} || {user?.mobile || "N/A"}
</p>

        </div>
      </div>)}

      <h2 className="text-center underline m-3 bg-white text-black">TRANSFER HISTORY</h2>

      {/* Invoice Details */}
      <div className="flex my-5">
        <div className="flex border-2 border-black h-auto">
          <div className="p-3 text-xs w-1/2">
            <p className="flex">
              <span className="font-medium">TransactionNo.:</span> {data.id}
            </p>
            <p>
              <span className="font-medium">Date :</span> {data.date}
            </p>
            {/* <p>
              <span className="font-medium">Type Of Sales :</span> {data.type}
            </p> */}
          </div>

          <div
            className="mx-10 p-3 text-xs w-1/2"
            style={{ borderLeft: "2px solid black" }}
          >
            <h3 className="underline text-sm">Customer Details:</h3>
            <p>{data.customerDetail.name}</p>
            <p>{data.customerDetail.mobile}</p>
            <p>{data.customerDetail.email}</p>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <table
        className="text-xs"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <thead>
          <tr>
            <th style={styles.tableCell}>S. No</th>
            <th style={styles.tableCell}>DESCRIPTION</th>
            <th style={styles.tableCell}>QTY</th>
            {/* <th style={styles.tableCell}>AMOUNT</th> */}
          </tr>
        </thead>
        <tbody>
          {data.products.map((item, index) => (
            <tr key={index}>
              <td style={styles.tableCell}>{item.serialNumber}</td>
              <td
                style={styles.tableCell}
              >{`${item.brand} ${item.model} ${item.variant} ${item.condition}`}</td>
              <td style={styles.tableCell}>{"1"}</td>
              {/* <td style={styles.tableCell}>{item.distributorPrice || item.retailerPrice}/-</td> */}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Total Amount Section */}
      {/* <table
        className="text-xs"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
          textAlign: "end",
        }}
      >
        <tbody>
          <tr>
            <td style={styles.verticalTableCell}>
              <strong>Total Amount</strong>
            </td>
            <td style={styles.verticalTableCell}>{totalAmount.toFixed(2)}/-</td>
          </tr>
          <tr>
            <td style={styles.verticalTableCell}>
              <strong>Amount in Words</strong>
            </td>
            <td style={styles.verticalTableCell}>{convertToWords(totalAmount)} only</td>
          </tr>
        </tbody>
      </table> */}

      {/* sign section  */}
      <div className="w-full text-xs flex border-[1px] border-black pt-14">
        
          <div className="w-full text-sm p-3 flex justify-end">
            <div>
            <p>.................................</p>
            <p>Authorised signature</p>
            </div>
        
          </div>
      </div>

      {/* Footer Section */}
      <div>
        {/* <p>
          <strong>Declaration:</strong> We declare that this invoice shows the
          actual price of goods and services and that all particulars are true
          and correct.
        </p>
        <p>Subject to Kolkata Jurisdiction</p> */}
      </div>
    </div>
  );
});

// Main InvoiceContainer Component
const InvoiceContainer = ({ invoiceDetails }) => {
  const invoiceRef = useRef();

  const generatePDF = () => {
    const element = invoiceRef.current;

    const options = {
      margin: 1,
      filename: "Invoice.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <div>
      <button
        onClick={generatePDF}
        className="px-4 py-2 bg-blue-500 text-white rounded mb-4"
      >
        Generate PDF
      </button>
      <InvoiceTemplate ref={invoiceRef} data={invoiceDetails} />
    </div>
  );
};

export default InvoiceContainer;
